import React from "react";
import { Grid, Row, Col, Nav } from "react-bootstrap";
import { Switch, Route, Redirect } from "react-router";

import KompressorWartungContainer from "./KompressorWartungContainer";
import KompressorWartungTabelleContainer from "./KompressorWartungTabelleContainer";

import AlmigLink from "../grundelemente/AlmigLink";
import BreadcrumbContainer from "../grundelemente/BreadcrumbContainer";
import OnlyTimeInfoPanel from "../grundelemente/OnlyTimeInfoPanel";
import VerbundsteuerungContainer from "../uebersicht/VerbundsteuerungContainer";
import VerbundInfoPanelContainer from "../uebersicht/VerbundInfoPanelContainer";
import KompressorInfoPanelContainer from "../uebersicht/KompressorInfoPanelContainer";

const Wartung = () => (
	<Grid>
		<Row>
			<Col xs={12}>
				<BreadcrumbContainer />
			</Col>
		</Row>
		<Row>
			<Col sm={12} md={3}>
				<Nav stacked className="Navispalte">
					<AlmigLink to="/maintenance/overview" />
					<AlmigLink to="/maintenance/compressor" />
					<AlmigLink to="/maintenance/table" />
				</Nav>
			</Col>
			<Col sm={12} md={6} className="Mittelspalte">
				<Switch>
					<Route path="/maintenance/overview" component={VerbundsteuerungContainer} />
					<Route path="/maintenance/compressor" component={KompressorWartungContainer} />
					<Route path="/maintenance/table" component={KompressorWartungTabelleContainer} />
					<Redirect exact from="/maintenance" to="/maintenance/overview" />
				</Switch>
			</Col>
			<Col sm={12} md={3}>
				<Switch>
					<Route path="/maintenance/overview" component={VerbundInfoPanelContainer} />
					<Route path="/maintenance/compressor/:compressorIndex" component={KompressorInfoPanelContainer} />
					<Route path="/maintenance/table" component={OnlyTimeInfoPanel} />
				</Switch>
			</Col>
		</Row>
	</Grid>
);

export default Wartung;
